import {ACTION_TYPES} from './reducer';

export const setMessageModal = (payload) => {
  return {
    type: ACTION_TYPES.MESSAGE_MODAL,
    payload: payload,
  };
};
